import { render, staticRenderFns } from "./specification-tab.vue?vue&type=template&id=308df30c&scoped=true"
import script from "./specification-tab.vue?vue&type=script&lang=js"
export * from "./specification-tab.vue?vue&type=script&lang=js"
import style0 from "./specification-tab.vue?vue&type=style&index=0&id=308df30c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308df30c",
  null
  
)

export default component.exports